/**
 * angular-bootstrap-calendar - A pure AngularJS bootstrap themed responsive calendar that can display events and has views for year, month, week and day
 * @version v0.11.0
 * @link https://github.com/mattlewis92/angular-bootstrap-calendar
 * @license MIT
 */
!(function (e, t) {
  'use strict';
  t.module('mwl.calendar', []),
    t.module('mwl.calendar').constant('moment', e.moment),
    t.module('mwl.calendar').constant('interact', e.interact),
    t.module('mwl.calendar').factory('calendarTitle', [
      'moment',
      'calendarConfig',
      'calendarHelper',
      function (e, t, n) {
        function a(e) {
          return n.formatDate(e, t.titleFormats.day);
        }
        function r(n) {
          var a = t.titleFormats.week;
          return a.replace('{week}', e(n).week()).replace('{year}', e(n).format('YYYY'));
        }
        function o(e) {
          return n.formatDate(e, t.titleFormats.month);
        }
        function i(e) {
          return n.formatDate(e, t.titleFormats.year);
        }
        return { day: a, week: r, month: o, year: i };
      },
    ]),
    t.module('mwl.calendar').factory('calendarHelper', [
      'dateFilter',
      'moment',
      'calendarConfig',
      function (e, n, a) {
        function r(t, r) {
          return 'angular' === a.dateFormatter
            ? e(n(t).toDate(), r)
            : 'moment' === a.dateFormatter
            ? n(t).format(r)
            : void 0;
        }
        function o(e, t, a) {
          if (!a) return a;
          var r = n(t).diff(n(e));
          return n(a).add(r);
        }
        function i(e, a, r) {
          var i = n(e.startsAt),
            l = n(e.endsAt || e.startsAt);
          if (((a = n(a)), (r = n(r)), t.isDefined(e.recursOn))) {
            switch (e.recursOn) {
              case 'year':
                i.set({ year: a.year() });
                break;
              case 'month':
                i.set({ year: a.year(), month: a.month() });
                break;
              default:
                throw new Error(
                  'Invalid value (' +
                    e.recursOn +
                    ') given for recurs on. Can only be year, month or week.',
                );
            }
            l = o(e.startsAt, i, l);
          }
          return (
            (i.isAfter(a) && i.isBefore(r)) ||
            (l.isAfter(a) && l.isBefore(r)) ||
            (i.isBefore(a) && l.isAfter(r)) ||
            i.isSame(a) ||
            l.isSame(r)
          );
        }
        function l(e, t, n) {
          return e.filter(function (e) {
            return i(e, t, n);
          });
        }
        function d(e, t, a) {
          var r = n(e).startOf(t),
            o = n(e).endOf(t);
          return l(a, r, o);
        }
        function s(e) {
          return e.filter(function (e) {
            return e.incrementsBadgeTotal !== !1;
          }).length;
        }
        function c() {
          for (var e = [], t = 0; 7 > t; ) e.push(r(n().weekday(t++), a.dateFormats.weekDay));
          return e;
        }
        function u(e, t) {
          for (var o = [], i = d(t, 'year', e), c = n(t).startOf('year'), u = 0; 12 > u; ) {
            var m = c.clone(),
              f = m.clone().endOf('month'),
              w = l(i, m, f);
            o.push({
              label: r(m, a.dateFormats.month),
              isToday: m.isSame(n().startOf('month')),
              events: w,
              date: m,
              badgeTotal: s(w),
            }),
              c.add(1, 'month'),
              u++;
          }
          return o;
        }
        function m(e, t) {
          var r,
            o = n(t).startOf('month'),
            i = o.clone().startOf('week'),
            d = n(t).endOf('month').endOf('week');
          r = a.displayAllMonthEvents ? l(e, i, d) : l(e, o, o.clone().endOf('month'));
          for (var c = [], u = n().startOf('day'); i.isBefore(d); ) {
            var m = i.month() === n(t).month(),
              f = [];
            (m || a.displayAllMonthEvents) && (f = l(r, i, i.clone().endOf('day'))),
              c.push({
                label: i.date(),
                date: i.clone(),
                inMonth: m,
                isPast: u.isAfter(i),
                isToday: u.isSame(i),
                isFuture: u.isBefore(i),
                isWeekend: [0, 6].indexOf(i.day()) > -1,
                events: f,
                badgeTotal: s(f),
              }),
              i.add(1, 'day');
          }
          return c;
        }
        function f(e, t) {
          for (
            var o = n(t).startOf('week'),
              i = n(t).endOf('week'),
              d = o.clone(),
              s = [],
              c = n().startOf('day');
            s.length < 7;

          )
            s.push({
              weekDayLabel: r(d, a.dateFormats.weekDay),
              date: d.clone(),
              dayLabel: r(d, a.dateFormats.day),
              isPast: d.isBefore(c),
              isToday: d.isSame(c),
              isFuture: d.isAfter(c),
              isWeekend: [0, 6].indexOf(d.day()) > -1,
            }),
              d.add(1, 'day');
          var u = l(e, o, i).map(function (e) {
            var t,
              a,
              r = n(e.startsAt).startOf('day'),
              l = n(e.endsAt || e.startsAt).startOf('day'),
              d = n(o).startOf('day'),
              s = n(i).startOf('day');
            return (
              (t = r.isBefore(d) || r.isSame(d) ? 0 : r.diff(d, 'days')),
              l.isAfter(s) && (l = s),
              r.isBefore(d) && (r = d),
              (a = n(l).diff(r, 'days') + 1),
              (e.daySpan = a),
              (e.dayOffset = t),
              e
            );
          });
          return { days: s, events: u };
        }
        function w(e, t, a, r, o) {
          var d = n(a || '00:00', 'HH:mm').hours(),
            s = n(r || '23:00', 'HH:mm').hours(),
            c = (60 / o) * 30,
            u = n(t).startOf('day').add(d, 'hours'),
            m = n(t).startOf('day').add(s, 'hours'),
            f = (s - d + 1) * c,
            w = c / 60,
            v = [],
            p = l(e, n(t).startOf('day').toDate(), n(t).endOf('day').toDate());
          return p
            .map(function (e) {
              if (
                ((e.top = n(e.startsAt).isBefore(u)
                  ? 0
                  : n(e.startsAt).startOf('minute').diff(u.startOf('minute'), 'minutes') * w - 2),
                n(e.endsAt || e.startsAt).isAfter(m))
              )
                e.height = f - e.top;
              else {
                var t = e.startsAt;
                n(e.startsAt).isBefore(u) && (t = u.toDate()),
                  (e.height = e.endsAt ? n(e.endsAt || e.startsAt).diff(t, 'minutes') * w : 30);
              }
              return e.top - e.height > f && (e.height = 0), (e.left = 0), e;
            })
            .filter(function (e) {
              return e.height > 0;
            })
            .map(function (e) {
              var t = !0;
              return (
                v.forEach(function (n, a) {
                  var r = !0;
                  n.forEach(function (t) {
                    (i(e, t.startsAt, t.endsAt || t.startsAt) ||
                      i(t, e.startsAt, e.endsAt || e.startsAt)) &&
                      (r = !1);
                  }),
                    r && t && ((t = !1), (e.left = 150 * a), v[a].push(e));
                }),
                t && ((e.left = 150 * v.length), v.push([e])),
                e
              );
            });
        }
        function v(e, t, a, r, o) {
          var i = f(e, t),
            l = [];
          return (
            i.days.forEach(function (e) {
              var t = i.events.filter(function (t) {
                  return n(t.startsAt).startOf('day').isSame(n(e.date).startOf('day'));
                }),
                d = w(t, e.date, a, r, o);
              l = l.concat(d);
            }),
            (i.events = l),
            i
          );
        }
        function p(e, t, a) {
          var r = n(e || '00:00', 'HH:mm'),
            o = n(t || '23:00', 'HH:mm'),
            i = (60 / a) * 30;
          return (o.diff(r, 'hours') + 1) * i + 2;
        }
        return {
          getWeekDayNames: c,
          getYearView: u,
          getMonthView: m,
          getWeekView: f,
          getDayView: w,
          getWeekViewWithTimes: v,
          getDayViewHeight: p,
          adjustEndDateFromStartDiff: o,
          formatDate: r,
          eventIsInPeriod: i,
        };
      },
    ]),
    t.module('mwl.calendar').service('calendarDebounce', [
      '$timeout',
      function (e) {
        function t(t, n, a) {
          var r;
          return function () {
            function o() {
              (r = null), a || t.apply(i, l);
            }
            var i = this,
              l = arguments,
              d = a && !r;
            e.cancel(r), (r = e(o, n)), d && t.apply(i, l);
          };
        }
        return t;
      },
    ]),
    t.module('mwl.calendar').provider('calendarConfig', function () {
      var e = {
          angular: {
            date: { hour: 'ha', day: 'd MMM', month: 'MMMM', weekDay: 'EEEE' },
            title: {
              day: 'EEEE d MMMM, yyyy',
              week: 'Week {week} of {year}',
              month: 'MMMM yyyy',
              year: 'yyyy',
            },
          },
          moment: {
            date: { hour: 'ha', day: 'D MMM', month: 'MMMM', weekDay: 'dddd' },
            title: {
              day: 'dddd D MMMM, YYYY',
              week: 'Week {week} of {year}',
              month: 'MMMM YYYY',
              year: 'YYYY',
            },
          },
        },
        n = 'angular',
        a = t.copy(e[n].date),
        r = t.copy(e[n].title),
        o = !1,
        i = { eventsLabel: 'Events', timeLabel: 'Time' },
        l = !1,
        d = this;
      (d.setDateFormats = function (e) {
        return t.extend(a, e), d;
      }),
        (d.setTitleFormats = function (e) {
          return t.extend(r, e), d;
        }),
        (d.setI18nStrings = function (e) {
          return t.extend(i, e), d;
        }),
        (d.setDisplayAllMonthEvents = function (e) {
          return (l = e), d;
        }),
        (d.setDateFormatter = function (o) {
          if (-1 === ['angular', 'moment'].indexOf(o))
            throw new Error('Invalid date formatter. Allowed types are angular and moment.');
          return (n = o), (a = t.copy(e[n].date)), (r = t.copy(e[n].title)), d;
        }),
        (d.showTimesOnWeekView = function (e) {
          return (o = e), d;
        }),
        (d.$get = function () {
          return {
            dateFormats: a,
            titleFormats: r,
            i18nStrings: i,
            displayAllMonthEvents: l,
            dateFormatter: n,
            showTimesOnWeekView: o,
          };
        });
    }),
    t.module('mwl.calendar').filter('calendarTruncateEventTitle', function () {
      return function (e, t, n) {
        return e ? (e.length >= t && e.length / 20 > n / 30 ? e.substr(0, t) + '...' : e) : '';
      };
    }),
    t.module('mwl.calendar').filter('calendarLimitTo', [
      'limitToFilter',
      function (e) {
        return t.version.minor >= 4
          ? e
          : function (e, n, a) {
              return (
                (n = Math.abs(Number(n)) === 1 / 0 ? Number(n) : parseInt(n)),
                isNaN(n)
                  ? e
                  : (t.isNumber(e) && (e = e.toString()),
                    t.isArray(e) || t.isString(e)
                      ? ((a = !a || isNaN(a) ? 0 : parseInt(a)),
                        (a = 0 > a && a >= -e.length ? e.length + a : a),
                        n >= 0
                          ? e.slice(a, a + n)
                          : 0 === a
                          ? e.slice(n, e.length)
                          : e.slice(Math.max(0, a + n), a))
                      : e)
              );
            };
      },
    ]),
    t
      .module('mwl.calendar')
      .controller('MwlElementDimensionsCtrl', [
        '$element',
        '$scope',
        '$parse',
        '$attrs',
        function (e, t, n, a) {
          n(a.mwlElementDimensions).assign(t, {
            width: e[0].offsetWidth,
            height: e[0].offsetHeight,
          });
        },
      ])
      .directive('mwlElementDimensions', function () {
        return { restrict: 'A', controller: 'MwlElementDimensionsCtrl' };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlDroppableCtrl', [
        '$element',
        '$scope',
        '$parse',
        '$attrs',
        'interact',
        function (e, n, a, r, o) {
          if (o) {
            o(e[0]).dropzone({
              ondragenter: function (e) {
                t.element(e.target).addClass('drop-active');
              },
              ondragleave: function (e) {
                t.element(e.target).removeClass('drop-active');
              },
              ondropdeactivate: function (e) {
                t.element(e.target).removeClass('drop-active');
              },
              ondrop: function (e) {
                e.relatedTarget.dropData &&
                  (a(r.onDrop)(n, { dropData: e.relatedTarget.dropData }), n.$apply());
              },
            });
            var i = n.$on('$destroy', function () {
              i(), o(e[0]).unset();
            });
          }
        },
      ])
      .directive('mwlDroppable', function () {
        return { restrict: 'A', controller: 'MwlDroppableCtrl' };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlDraggableCtrl', [
        '$element',
        '$scope',
        '$window',
        '$parse',
        '$attrs',
        '$timeout',
        'interact',
        function (e, n, a, r, o, i, l) {
          function d(e, t) {
            return e.css('transform', t).css('-ms-transform', t).css('-webkit-transform', t);
          }
          function s() {
            return r(o.mwlDraggable)(n);
          }
          function c(e, t, n) {
            var a = { x: e, y: t };
            return n && n.x && (a.x /= n.x), n && n.y && (a.y /= n.y), a;
          }
          if (l) {
            var u, m;
            o.snapGrid && ((m = r(o.snapGrid)(n)), (u = { targets: [l.createSnapGrid(m)] })),
              l(e[0]).draggable({
                snap: u,
                onstart: function (e) {
                  s() &&
                    (t.element(e.target).addClass('dragging-active'),
                    (e.target.dropData = r(o.dropData)(n)),
                    (e.target.style.pointerEvents = 'none'),
                    o.onDragStart && (r(o.onDragStart)(n), n.$apply()));
                },
                onmove: function (e) {
                  if (s()) {
                    var i = t.element(e.target),
                      l = (parseFloat(i.attr('data-x')) || 0) + (e.dx || 0),
                      u = (parseFloat(i.attr('data-y')) || 0) + (e.dy || 0);
                    switch (r(o.axis)(n)) {
                      case 'x':
                        u = 0;
                        break;
                      case 'y':
                        l = 0;
                    }
                    a.getComputedStyle(i[0]).position || i.css('position', 'relative'),
                      d(i, 'translate(' + l + 'px, ' + u + 'px)')
                        .css('z-index', 1e3)
                        .attr('data-x', l)
                        .attr('data-y', u),
                      o.onDrag && (r(o.onDrag)(n, c(l, u, m)), n.$apply());
                  }
                },
                onend: function (e) {
                  if (s()) {
                    var a = t.element(e.target),
                      l = a.attr('data-x'),
                      u = a.attr('data-y');
                    (e.target.style.pointerEvents = 'auto'),
                      o.onDragEnd && (r(o.onDragEnd)(n, c(l, u, m)), n.$apply()),
                      i(function () {
                        d(a, null)
                          .removeAttr('data-x')
                          .removeAttr('data-y')
                          .removeClass('dragging-active');
                      }, 50);
                  }
                },
              });
            var f = n.$on('$destroy', function () {
              f(), l(e[0]).unset();
            });
          }
        },
      ])
      .directive('mwlDraggable', function () {
        return { restrict: 'A', controller: 'MwlDraggableCtrl' };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlDateModifierCtrl', [
        '$element',
        '$attrs',
        '$scope',
        'moment',
        function (e, n, a, r) {
          function o() {
            t.isDefined(n.setToToday)
              ? (a.date = new Date())
              : t.isDefined(n.increment)
              ? (a.date = r(a.date).add(1, a.increment).toDate())
              : t.isDefined(n.decrement) && (a.date = r(a.date).subtract(1, a.decrement).toDate()),
              a.$apply();
          }
          e.bind('click', o),
            a.$on('$destroy', function () {
              e.unbind('click', o);
            });
        },
      ])
      .directive('mwlDateModifier', function () {
        return {
          restrict: 'A',
          controller: 'MwlDateModifierCtrl',
          scope: { date: '=', increment: '=', decrement: '=' },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCollapseFallbackCtrl', [
        '$scope',
        '$attrs',
        '$element',
        function (e, t, n) {
          var a = e.$watch(t.mwlCollapseFallback, function (e) {
              e ? n.addClass('ng-hide') : n.removeClass('ng-hide');
            }),
            r = e.$on('$destroy', function () {
              r(), a();
            });
        },
      ])
      .directive('mwlCollapseFallback', [
        '$injector',
        function (e) {
          return e.has('collapseDirective')
            ? {}
            : { restrict: 'A', controller: 'MwlCollapseFallbackCtrl' };
        },
      ]),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarYearCtrl', [
        '$scope',
        'moment',
        'calendarHelper',
        function (e, t, n) {
          var a = this,
            r = !0;
          e.$on('calendar.refreshView', function () {
            (a.view = n.getYearView(e.events, e.currentDay)),
              e.autoOpen &&
                r &&
                ((r = !1),
                a.view.forEach(function (n) {
                  t(e.currentDay).startOf('month').isSame(n.date) && a.monthClicked(n, !0);
                }));
          }),
            (a.monthClicked = function (t, n) {
              n || e.onTimespanClick({ calendarDate: t.date.toDate() }), (a.openRowIndex = null);
              var r = a.view.indexOf(t);
              r === a.openMonthIndex
                ? (a.openMonthIndex = null)
                : ((a.openMonthIndex = r), (a.openRowIndex = Math.floor(r / 4)));
            }),
            (a.handleEventDrop = function (a, r) {
              var o = t(a.startsAt).month(t(r).month()),
                i = n.adjustEndDateFromStartDiff(a.startsAt, o, a.endsAt);
              e.onEventDrop({
                calendarEvent: a,
                calendarDate: r,
                calendarNewEventStart: o.toDate(),
                calendarNewEventEnd: i.toDate(),
              });
            });
        },
      ])
      .directive('mwlCalendarYear', function () {
        return {
          templateUrl: 'src/templates/calendarYearView.html',
          restrict: 'EA',
          require: '^mwlCalendar',
          scope: {
            events: '=',
            currentDay: '=',
            onEventClick: '=',
            onEventDrop: '=',
            onEditEventClick: '=',
            onDeleteEventClick: '=',
            editEventHtml: '=',
            deleteEventHtml: '=',
            autoOpen: '=',
            onTimespanClick: '=',
          },
          controller: 'MwlCalendarYearCtrl as vm',
          link: function (e, t, n, a) {
            e.vm.calendarCtrl = a;
          },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarWeekCtrl', [
        '$scope',
        '$sce',
        'moment',
        'calendarHelper',
        'calendarConfig',
        function (e, t, n, a, r) {
          var o = this;
          (o.showTimes = r.showTimesOnWeekView),
            (o.$sce = t),
            e.$on('calendar.refreshView', function () {
              (o.dayViewHeight = a.getDayViewHeight(e.dayViewStart, e.dayViewEnd, e.dayViewSplit)),
                (o.view = o.showTimes
                  ? a.getWeekViewWithTimes(
                      e.events,
                      e.currentDay,
                      e.dayViewStart,
                      e.dayViewEnd,
                      e.dayViewSplit,
                    )
                  : a.getWeekView(e.events, e.currentDay));
            }),
            (o.weekDragged = function (t, a, r) {
              var o = n(t.startsAt).add(a, 'days'),
                i = n(t.endsAt).add(a, 'days');
              if (r) {
                var l = r * e.dayViewSplit;
                (o = o.add(l, 'minutes')), (i = i.add(l, 'minutes'));
              }
              delete t.tempStartsAt,
                e.onEventDrop({
                  calendarEvent: t,
                  calendarNewEventStart: o.toDate(),
                  calendarNewEventEnd: i.toDate(),
                });
            }),
            (o.tempTimeChanged = function (t, a) {
              var r = a * e.dayViewSplit;
              t.tempStartsAt = n(t.startsAt).add(r, 'minutes').toDate();
            });
        },
      ])
      .directive('mwlCalendarWeek', function () {
        return {
          templateUrl: 'src/templates/calendarWeekView.html',
          restrict: 'EA',
          require: '^mwlCalendar',
          scope: {
            events: '=',
            currentDay: '=',
            onEventClick: '=',
            onEventDrop: '=',
            dayViewStart: '=',
            dayViewEnd: '=',
            dayViewSplit: '=',
          },
          controller: 'MwlCalendarWeekCtrl as vm',
          link: function (e, t, n, a) {
            e.vm.calendarCtrl = a;
          },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarSlideBoxCtrl', [
        '$scope',
        '$sce',
        function (e, t) {
          var n = this;
          n.$sce = t;
          var a = e.$watch('isOpen', function (e) {
              n.shouldCollapse = !e;
            }),
            r = e.$on('$destroy', function () {
              r(), a();
            });
        },
      ])
      .directive('mwlCalendarSlideBox', function () {
        return {
          restrict: 'EA',
          templateUrl: 'src/templates/calendarSlideBox.html',
          replace: !0,
          controller: 'MwlCalendarSlideBoxCtrl as vm',
          require: ['^?mwlCalendarMonth', '^?mwlCalendarYear'],
          link: function (e, t, n, a) {
            (e.isMonthView = !!a[0]), (e.isYearView = !!a[1]);
          },
          scope: {
            isOpen: '=',
            events: '=',
            onEventClick: '=',
            editEventHtml: '=',
            onEditEventClick: '=',
            deleteEventHtml: '=',
            onDeleteEventClick: '=',
          },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarMonthCtrl', [
        '$scope',
        'moment',
        'calendarHelper',
        function (e, t, n) {
          var a = this,
            r = !0;
          e.$on('calendar.refreshView', function () {
            (a.weekDays = n.getWeekDayNames()), (a.view = n.getMonthView(e.events, e.currentDay));
            var o = Math.floor(a.view.length / 7);
            a.monthOffsets = [];
            for (var i = 0; o > i; i++) a.monthOffsets.push(7 * i);
            e.autoOpen &&
              r &&
              ((r = !1),
              a.view.forEach(function (n) {
                n.inMonth && t(e.currentDay).startOf('day').isSame(n.date) && a.dayClicked(n, !0);
              }));
          }),
            (a.dayClicked = function (t, n) {
              n || e.onTimespanClick({ calendarDate: t.date.toDate() }), (a.openRowIndex = null);
              var r = a.view.indexOf(t);
              r === a.openDayIndex
                ? (a.openDayIndex = null)
                : ((a.openDayIndex = r), (a.openRowIndex = Math.floor(r / 7)));
            }),
            (a.highlightEvent = function (e, t) {
              a.view.forEach(function (n) {
                if ((delete n.highlightClass, t)) {
                  var a = n.events.indexOf(e) > -1;
                  a && (n.highlightClass = 'day-highlight dh-event-' + e.type);
                }
              });
            }),
            (a.handleEventDrop = function (a, r) {
              var o = t(a.startsAt).date(t(r).date()).month(t(r).month()),
                i = n.adjustEndDateFromStartDiff(a.startsAt, o, a.endsAt);
              e.onEventDrop({
                calendarEvent: a,
                calendarDate: r,
                calendarNewEventStart: o.toDate(),
                calendarNewEventEnd: i.toDate(),
              });
            });
        },
      ])
      .directive('mwlCalendarMonth', function () {
        return {
          templateUrl: 'src/templates/calendarMonthView.html',
          restrict: 'EA',
          require: '^mwlCalendar',
          scope: {
            events: '=',
            currentDay: '=',
            onEventClick: '=',
            onEditEventClick: '=',
            onDeleteEventClick: '=',
            onEventDrop: '=',
            editEventHtml: '=',
            deleteEventHtml: '=',
            autoOpen: '=',
            onTimespanClick: '=',
          },
          controller: 'MwlCalendarMonthCtrl as vm',
          link: function (e, t, n, a) {
            e.vm.calendarCtrl = a;
          },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarHourListCtrl', [
        '$scope',
        'moment',
        'calendarConfig',
        'calendarHelper',
        function (e, t, n, a) {
          function r() {
            (o = t(e.dayViewStart || '00:00', 'HH:mm')),
              (i = t(e.dayViewEnd || '23:00', 'HH:mm')),
              (l.dayViewSplit = parseInt(e.dayViewSplit)),
              (l.hours = []);
            for (var r = t(o), d = 0; d <= i.diff(o, 'hours'); d++)
              l.hours.push({ label: a.formatDate(r, n.dateFormats.hour) }), r.add(1, 'hour');
          }
          var o,
            i,
            l = this,
            d = t.locale();
          e.$on('calendar.refreshView', function () {
            d !== t.locale() && ((d = t.locale()), r());
          }),
            r();
        },
      ])
      .directive('mwlCalendarHourList', function () {
        return {
          restrict: 'EA',
          templateUrl: 'src/templates/calendarHourList.html',
          controller: 'MwlCalendarHourListCtrl as vm',
          scope: { dayViewStart: '=', dayViewEnd: '=', dayViewSplit: '=' },
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarDayCtrl', [
        '$scope',
        '$timeout',
        '$sce',
        'moment',
        'calendarHelper',
        'calendarConfig',
        function (e, t, n, a, r, o) {
          var i = this;
          (i.calendarConfig = o),
            (i.$sce = n),
            e.$on('calendar.refreshView', function () {
              (i.dayViewHeight = r.getDayViewHeight(e.dayViewStart, e.dayViewEnd, e.dayViewSplit)),
                (i.view = r.getDayView(
                  e.events,
                  e.currentDay,
                  e.dayViewStart,
                  e.dayViewEnd,
                  e.dayViewSplit,
                ));
            }),
            (i.timeChanged = function (t, n) {
              var r = n * e.dayViewSplit,
                o = a(t.startsAt).add(r, 'minutes'),
                i = a(t.endsAt).add(r, 'minutes');
              delete t.tempStartsAt,
                e.onEventDrop({
                  calendarEvent: t,
                  calendarNewEventStart: o.toDate(),
                  calendarNewEventEnd: i.toDate(),
                });
            }),
            (i.tempTimeChanged = function (t, n) {
              var r = n * e.dayViewSplit;
              t.tempStartsAt = a(t.startsAt).add(r, 'minutes').toDate();
            });
        },
      ])
      .directive('mwlCalendarDay', function () {
        return {
          templateUrl: 'src/templates/calendarDayView.html',
          restrict: 'EA',
          require: '^mwlCalendar',
          scope: {
            events: '=',
            currentDay: '=',
            onEventClick: '=',
            onEventDrop: '=',
            dayViewStart: '=',
            dayViewEnd: '=',
            dayViewSplit: '=',
          },
          controller: 'MwlCalendarDayCtrl as vm',
        };
      }),
    t
      .module('mwl.calendar')
      .controller('MwlCalendarCtrl', [
        '$scope',
        '$timeout',
        '$window',
        '$locale',
        'moment',
        'calendarTitle',
        'calendarDebounce',
        function (e, n, a, r, o, i, l) {
          var d = this;
          (e.events = e.events || []),
            (d.changeView = function (t, n) {
              (e.view = t), (e.currentDay = n);
            }),
            (d.drillDown = function (t) {
              var n = o(t).toDate(),
                a = { year: 'month', month: 'day', week: 'day' };
              e.onDrillDownClick({ calendarDate: n, calendarNextView: a[e.view] }) !== !1 &&
                d.changeView(a[e.view], n);
            });
          var s = o(e.currentDay),
            c = t.copy(e.view),
            u = l(function () {
              i[e.view] && (e.viewTitle = i[e.view](e.currentDay)),
                (e.events = e.events.map(function (e, t) {
                  return Object.defineProperty(e, '$id', { enumerable: !1, value: t }), e;
                }));
              var n = o(e.currentDay),
                a = !0;
              s.clone().startOf(e.view).isSame(n.clone().startOf(e.view)) &&
                !s.isSame(n) &&
                e.view === c &&
                (a = !1),
                (s = n),
                (c = t.copy(e.view)),
                a && e.$broadcast('calendar.refreshView');
            }, 50),
            m = e.$watch(function () {
              return o.locale() + r.id;
            }, u),
            f = [];
          f.push(m),
            f.push(e.$watch('currentDay', u)),
            f.push(e.$watch('view', u)),
            f.push(e.$watch('events', u, !0));
          var w = e.$on('$destroy', function () {
            f.forEach(function (e) {
              e();
            });
          });
          f.push(w);
        },
      ])
      .directive('mwlCalendar', function () {
        return {
          templateUrl: 'src/templates/calendar.html',
          restrict: 'EA',
          scope: {
            events: '=',
            view: '=',
            viewTitle: '=',
            currentDay: '=',
            editEventHtml: '=',
            deleteEventHtml: '=',
            autoOpen: '=',
            onEventClick: '&',
            onEventDrop: '&',
            onEditEventClick: '&',
            onDeleteEventClick: '&',
            onTimespanClick: '&',
            onDrillDownClick: '&',
            dayViewStart: '@',
            dayViewEnd: '@',
            dayViewSplit: '@',
          },
          controller: 'MwlCalendarCtrl as vm',
        };
      });
})(window, angular);
//# sourceMappingURL=angular-bootstrap-calendar.min.js.map
